/**
 * Created by Allan on 2021/04/27.
 * Contact 84880528@qq.com.
 */
export default[
    {
        path:'/login',
        name:'login',
        meta:{
            title:'login',
        },
        hidden:true,
        leaf:true,
        component:resolve => require(['@/views/login/index'], resolve)
    }
]



// WEBPACK FOOTER //
// ./src/router/map/login.js